import React from 'react';

const FlashIcon = ({ cssClass }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={cssClass}
  >
    <title>Express</title>
    <path d="M13.5 2 4 14h6l-1.5 8L20 10h-6.5l0-8z" />
  </svg>
);

export default FlashIcon;
